const DONATE_TRIGGER_SELECTOR = [
  'a[href^="https://secure.everyaction.com/cQv0Z8uJaUWt0Tv_whIKGw2"]',
  'a[href*="networkforgood"]',
  'a[href*="/donate"]',
  'a[data-donate-trigger]',
  'button[data-donate-trigger]',
  '.btn-donate',
  '.site-header__donate',
  '.all-stories-donate-btn',
  '.support-dev__donate-button',
  '.support-dev__hero-donate',
  '.support-dev__ways-donate',
  '.awards-dev__hero-donate',
  '.about-dev__donate-button',
  '.impact-dev__hero-donate a',
].join(', ');

const DONATE_TEXT_PATTERN = /^\s*donate(\s|$|→|➔)/i;

let isBound = false;

function isDonateTrigger(element) {
  if (!element || element.closest('[data-donate-modal]')) {
    return false;
  }

  if (element.matches(DONATE_TRIGGER_SELECTOR)) {
    return true;
  }

  if (element.matches('a, button')) {
    const label = (element.textContent || '').replace(/\s+/g, ' ').trim();
    if (DONATE_TEXT_PATTERN.test(label)) {
      return true;
    }
  }

  return false;
}

function getModal() {
  return document.querySelector('[data-donate-modal]');
}

function closeCompetingOverlays() {
  const siteMenu = document.querySelector('[data-site-menu]');

  if (siteMenu) {
    siteMenu.classList.remove('is-active');
    siteMenu.setAttribute('aria-hidden', 'true');
  }

  document.querySelectorAll('[data-site-menu-toggle]').forEach((button) => {
    button.setAttribute('aria-expanded', 'false');
  });
  document.body.classList.remove('site-menu-open');

  document.querySelectorAll('.edition-lightbox.is-open .edition-lightbox-close').forEach((button) => {
    button.click();
  });

  document.querySelectorAll('.fuller-embed-modal:not([hidden])').forEach((overlay) => {
    overlay.querySelector('[data-close-modal]')?.click();
  });

  document.querySelectorAll('dialog[open]').forEach((dialog) => {
    if (typeof dialog.close === 'function') {
      dialog.close();
    }
  });
}

function normalizeAmountLabels(ngpForm) {
  ngpForm.querySelectorAll('label.label-amount:not(.label-otheramount)').forEach((label) => {
    const anchor = label.querySelector('a');
    const input = label.querySelector('input[type="radio"]');
    if (!anchor || !input) {
      return;
    }

    if (!anchor.textContent.trim()) {
      const text = [...label.childNodes]
        .filter((node) => node.nodeType === Node.TEXT_NODE)
        .map((node) => node.textContent.trim())
        .filter(Boolean)
        .join(' ');

      if (text) {
        anchor.textContent = text;
        [...label.childNodes]
          .filter((node) => node.nodeType === Node.TEXT_NODE)
          .forEach((node) => node.remove());
      }
    }

    if (input.nextElementSibling !== anchor) {
      label.insertBefore(input, anchor);
    }
  });
}

function positionFormAccent(ngpForm) {
  const formWrap = ngpForm.closest('.donate-modal__form-wrap');
  const accent = formWrap?.querySelector('.donate-modal__form-accent');
  const header = ngpForm.querySelector('.donate-modal__form-header');
  const activeStep = ngpForm.querySelector('.at-steps .at-step.active');

  if (!accent || !header || !activeStep || !formWrap) {
    return;
  }

  const wrapRect = formWrap.getBoundingClientRect();
  const headerRect = header.getBoundingClientRect();
  const stepRect = activeStep.getBoundingClientRect();

  accent.style.top = `${headerRect.top - wrapRect.top}px`;
  accent.style.left = `${stepRect.left - wrapRect.left}px`;
  accent.style.width = `${Math.max(stepRect.width, 76)}px`;
  accent.hidden = false;
}

function updateActiveStep(ngpForm) {
  const activeStep = ngpForm.querySelector('.at-steps .at-step.active');
  ngpForm.dataset.atStep = activeStep?.dataset?.step ?? '0';
  positionFormAccent(ngpForm);
}

function repairFormHeader(ngpForm) {
  const header = ngpForm.querySelector('.donate-modal__form-header');
  if (!header) {
    return;
  }

  const paymentInHeader = header.querySelector('.at-radio-set.at-radio-set-buttons');
  if (paymentInHeader) {
    const paymentFieldset = ngpForm.querySelector('.at-fieldset.PaymentInformation');
    if (paymentFieldset) {
      paymentFieldset.prepend(paymentInHeader);
    } else {
      header.after(paymentInHeader);
    }
  }

  const frequency = ngpForm.querySelector('.form-item-selectedfrequency');
  if (frequency && !header.contains(frequency)) {
    header.appendChild(frequency);
  }
}

function buildFormHeader(ngpForm, steps) {
  if (ngpForm.querySelector('.donate-modal__form-header')) {
    repairFormHeader(ngpForm);
    return;
  }

  const header = document.createElement('div');
  header.className = 'donate-modal__form-header';
  steps.parentNode.insertBefore(header, steps);
  header.appendChild(steps);

  const frequency = ngpForm.querySelector('.form-item-selectedfrequency');
  if (frequency) {
    header.appendChild(frequency);
  }

  repairFormHeader(ngpForm);
}

function markPaymentMethods(ngpForm) {
  const paymentSet = ngpForm.querySelector('.at-radio-set.at-radio-set-buttons');
  if (paymentSet) {
    paymentSet.classList.add('donate-modal__payment-methods');
  }
}

function normalizePaymentMethodOrder(ngpForm) {
  const paymentSet = ngpForm.querySelector('.at-radio-set.at-radio-set-buttons');
  if (!paymentSet) {
    return;
  }

  const credit = paymentSet.querySelector('.at-credit-card-button-wrapper');
  const eft = paymentSet.querySelector('.at-eft-button-wrapper');

  if (credit && eft && eft.nextElementSibling !== credit) {
    paymentSet.insertBefore(eft, credit);
  }
}

function updatePaymentGroupState(paymentGroup) {
  const walletButtons = paymentGroup.querySelectorAll('.at-express-checkout .btn-at, .at-wallet-buttons .btn-at');
  paymentGroup.classList.toggle('donate-modal__payment-group--single-wallet', walletButtons.length === 1);
}

function movePaymentToAmountStep(ngpForm) {
  const tributeFieldset = ngpForm.querySelector('.at-fieldset.TributeGift');
  const coverCosts = ngpForm.querySelector('label.CoverCostsAmount');
  const paymentFieldset = ngpForm.querySelector('.at-fieldset.PaymentInformation');
  const paymentButtons = ngpForm.querySelector('.at-payment-method-buttons');
  const expressCheckout = ngpForm.querySelector('.at-express-checkout, .at-express-checkout-element-wrapper');
  const walletButtons = ngpForm.querySelector('.at-wallet-buttons');

  if (!paymentFieldset || (!paymentButtons && !expressCheckout && !walletButtons)) {
    return;
  }

  let paymentGroup = ngpForm.querySelector('.donate-modal__payment-group');
  if (!paymentGroup) {
    paymentGroup = document.createElement('div');
    paymentGroup.className = 'donate-modal__payment-group';
  }

  [expressCheckout, walletButtons, paymentButtons].filter(Boolean).forEach((element) => {
    if (element.parentElement !== paymentGroup) {
      paymentGroup.appendChild(element);
    }
  });

  const insertAfter = tributeFieldset || coverCosts;
  if (insertAfter && insertAfter.nextElementSibling !== paymentGroup) {
    insertAfter.after(paymentGroup);
  }

  normalizePaymentMethodOrder(ngpForm);
  updatePaymentGroupState(paymentGroup);
  markPaymentMethods(ngpForm);
}

function schedulePaymentLayout(ngpForm) {
  if (ngpForm.dataset.paymentLayoutScheduled === '1') {
    movePaymentToAmountStep(ngpForm);
    return;
  }

  [0, 150, 500, 1200, 2500].forEach((delay) => {
    window.setTimeout(() => movePaymentToAmountStep(ngpForm), delay);
  });

  ngpForm.dataset.paymentLayoutScheduled = '1';
}

function watchActiveStep(ngpForm) {
  if (ngpForm.dataset.stepWatchBound === '1') {
    updateActiveStep(ngpForm);
    return;
  }

  updateActiveStep(ngpForm);

  const observer = new MutationObserver(() => updateActiveStep(ngpForm));
  observer.observe(ngpForm, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class'],
  });

  ngpForm.dataset.stepWatchBound = '1';
}

function normalizeOtherAmountLabel(ngpForm) {
  const label = ngpForm.querySelector('label.label-otheramount');
  if (!label) {
    return;
  }

  [...label.childNodes]
    .filter((node) => node.nodeType === Node.TEXT_NODE)
    .forEach((node) => node.remove());
}

function enhanceDonateForm(root) {
  const ngpForm = root.querySelector('.donate-modal__ngp-form');
  if (!ngpForm) {
    return false;
  }

  const steps = ngpForm.querySelector('.at-steps');
  if (!steps) {
    return false;
  }

  normalizeAmountLabels(ngpForm);
  normalizeOtherAmountLabel(ngpForm);
  buildFormHeader(ngpForm, steps);
  movePaymentToAmountStep(ngpForm);
  schedulePaymentLayout(ngpForm);
  markPaymentMethods(ngpForm);
  watchActiveStep(ngpForm);
  requestAnimationFrame(() => positionFormAccent(ngpForm));
  ngpForm.classList.add('is-form-ready');
  return true;
}

function openDonateModal() {
  const modal = getModal();
  if (!modal) {
    return;
  }

  closeCompetingOverlays();
  modal.hidden = false;
  modal.setAttribute('aria-hidden', 'false');
  modal.classList.add('is-open');
  document.body.classList.add('has-donate-modal-open');
  enhanceDonateForm(modal);

  const closeButton = modal.querySelector('[data-donate-modal-close]');
  if (closeButton) {
    closeButton.focus();
  }
}

function closeDonateModal() {
  const modal = getModal();
  if (!modal) {
    return;
  }

  modal.classList.remove('is-open');
  modal.hidden = true;
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('has-donate-modal-open');
}

function handleDocumentClick(event) {
  const trigger = event.target.closest('a, button');
  if (!isDonateTrigger(trigger)) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  openDonateModal();
}

function handleDocumentKeydown(event) {
  if (event.key !== 'Escape') {
    return;
  }

  const modal = getModal();
  if (modal && !modal.hidden) {
    closeDonateModal();
  }
}

function bindDonateModal() {
  if (isBound) {
    return;
  }

  const modal = getModal();
  if (!modal) {
    return;
  }

  document.addEventListener('click', handleDocumentClick, true);
  document.addEventListener('keydown', handleDocumentKeydown);

  modal.querySelectorAll('[data-donate-modal-close]').forEach((button) => {
    button.addEventListener('click', () => closeDonateModal());
  });

  watchDonateForm(modal);
  window.addEventListener('resize', handleFormAccentResize);
  isBound = true;
}

function handleFormAccentResize() {
  const modal = getModal();
  const ngpForm = modal?.querySelector('.donate-modal__ngp-form');

  if (modal && !modal.hidden && ngpForm) {
    positionFormAccent(ngpForm);
  }
}

function watchDonateForm(modal) {
  const ngpForm = modal.querySelector('.donate-modal__ngp-form');
  if (!ngpForm || ngpForm.dataset.formWatchBound === '1') {
    return;
  }

  const tryEnhance = () => enhanceDonateForm(modal);

  if (tryEnhance()) {
    ngpForm.dataset.formWatchBound = '1';
    return;
  }

  const observer = new MutationObserver(() => {
    if (tryEnhance()) {
      observer.disconnect();
    }
  });

  observer.observe(ngpForm, { childList: true, subtree: true });
  ngpForm.dataset.formWatchBound = '1';
}

function initDonateModal() {
  bindDonateModal();

  if (!isBound && initDonateModal.attempts < 20) {
    initDonateModal.attempts += 1;
    window.setTimeout(initDonateModal, 100);
  }
}

initDonateModal.attempts = 0;

export default initDonateModal;
export { openDonateModal, closeDonateModal, bindDonateModal };
